// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"ea702273","486":"4c0a084b","592":"fb5b2a71"}[chunkId] + ".chunk.js";
};